import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { doc, docData, docSnapshots, Firestore } from '@angular/fire/firestore';
import { TranslationClass } from '@sleipai/sleip-models';
import { map } from 'rxjs';

@Injectable()
export class TranslationsService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  fetchTranslationsByType(translationType: string) {
    return docSnapshots(
      doc(this.firestore, `/translations/${translationType}`)
    ).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((translation) => {
        return new TranslationClass({
          id: translation.id,
          ...translation.data(),
        });
      })
    );
  }

  getDeclineReasons() {
    const translationsRef = doc(this.firestore, `translations/decline`);

    return docData(translationsRef);
  }
}
